import { BRAND } from "../data/site";

// Horizontal lockup of the original arched-tree mark + "NJ THERAPY / ONLINE" wordmark.
export default function Logo({ size = "md", className = "" }) {
  const mark = size === "lg" ? "h-14 w-14" : size === "sm" ? "h-9 w-9" : "h-11 w-11";
  const top = size === "lg" ? "text-[22px]" : size === "sm" ? "text-[15px]" : "text-[18px]";
  const bottom = size === "lg" ? "text-[11px]" : size === "sm" ? "text-[8.5px]" : "text-[9.5px]";
  return (
    <span className={`inline-flex items-center gap-3 ${className}`}>
      <img src={BRAND.logoMark} alt="" aria-hidden="true" width="56" height="55" className={`${mark} object-contain`} />
      <span className="flex flex-col leading-none text-[#56584C]">
        <span className={`font-logo ${top} tracking-[0.16em]`}>NJ THERAPY</span>
        <span className="my-[5px] h-px w-full bg-[#56584C]/60" />
        <span className={`${bottom} tracking-[0.42em] font-light text-center`}>ONLINE</span>
      </span>
      <span className="sr-only">{BRAND.name}</span>
    </span>
  );
}
